import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpPanelWithHeadingComponent from './adpPanelWithHeading.component';

let adpPanelWithHeadingModule = angular.module('adpPanelWithHeading', [
  uiRouter
])

.component('adpPanelWithHeading', adpPanelWithHeadingComponent)

.name;

export default adpPanelWithHeadingModule;



// WEBPACK FOOTER //
// ./src/app/components/adpPanelWithHeading/adpPanelWithHeading.js